import { useEffect, useRef, useState } from "react";
import { Camera, Globe, Loader2, MessageSquare, Trash2 } from "lucide-react";
import { toast } from "sonner";
import api from "@/lib/api";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { COPPER } from "../VestaAuth";
import { B } from "./common";
import { Avatar } from "./PostCard";

export function FotoEdit({ d, setD, onFoto }) {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);
  const up = async (f) => {
    setBusy(true);
    try {
      const fd = new FormData(); fd.append("file", f);
      const r = await api.post(`${B}/me/foto`, fd, { headers: { "Content-Type": "multipart/form-data" } });
      setD({ ...d, foto: r.data.foto }); onFoto?.(r.data.foto); toast.success("Foto profilo aggiornata");
    } catch (e) { toast.error(e.response?.data?.detail || "Caricamento non riuscito"); }
    setBusy(false);
  };
  const del = async () => {
    try { await api.delete(`${B}/me/foto`); setD({ ...d, foto: null }); onFoto?.(null); toast.success("Foto rimossa: verrà mostrato il logo aziendale"); } catch { toast.error("Operazione non riuscita"); }
  };
  return (
    <div className="flex items-center gap-3 text-xs">
      <input ref={ref} type="file" accept="image/*" className="hidden" data-testid="bacheca-me-foto-input" onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ""; if (f) up(f); }} />
      <button type="button" onClick={() => ref.current?.click()} disabled={busy} className="flex items-center gap-1 font-bold uppercase tracking-widest transition-opacity hover:opacity-80 disabled:opacity-50" style={{ color: COPPER }} data-testid="bacheca-me-foto-upload">
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Camera className="h-3.5 w-3.5" />}{d.foto ? "Cambia foto" : "Carica la tua foto"}
      </button>
      {d.foto && <button type="button" onClick={del} className="flex items-center gap-1 font-bold uppercase tracking-widest text-neutral-500 hover:text-red-400" data-testid="bacheca-me-foto-delete"><Trash2 className="h-3.5 w-3.5" />Rimuovi</button>}
    </div>
  );
}

export default function AuthorDialog({ uid, me, onClose, onMessage, onFoto }) {
  const [d, setD] = useState(null);
  useEffect(() => { if (uid) { setD(null); api.get(`${B}/autore/${uid}`).then((r) => setD(r.data)).catch(() => onClose()); } }, [uid, onClose]);
  const p = d?.partner;
  const mine = uid && uid === me?.uid;
  return (
    <Dialog open={!!uid} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md border-[#2A303C] bg-[#16191E] text-white" data-testid="bacheca-author-dialog">
        <DialogHeader><DialogTitle className="font-heading text-lg" style={{ color: COPPER }}>Profilo</DialogTitle><DialogDescription className="sr-only">Profilo installatore</DialogDescription></DialogHeader>
        {!d ? <Loader2 className="h-5 w-5 animate-spin" style={{ color: COPPER }} /> : (
          <div className="space-y-4">
            <div className="flex items-center gap-4">
              <Avatar a={{ ...d, partner_name: p?.name }} foto={d.foto} logo={p?.has_logo ? `/api/vesta/bacheca/logo/${p.id}` : null} size={84} testid="bacheca-author-avatar" />
              <div className="min-w-0 space-y-1">
                <div className="font-heading text-lg font-extrabold" data-testid="bacheca-author-name">{d.staff ? d.name : p?.name || d.name}</div>
                <div className="text-xs text-[#9CA3AF]">{d.staff ? "Team Torri Solar" : [d.name, p?.city, p?.province && `(${p.province})`].filter(Boolean).join(" · ")}</div>
                <div className="text-xs text-[#6B7280]">{d.posts_count} post in bacheca</div>
                {mine && <FotoEdit d={d} setD={setD} onFoto={onFoto} />}
              </div>
            </div>
            {mine && !d.foto && <p className="text-[11px] text-[#6B7280]">Senza foto personale viene mostrato il logo {d.staff ? "Torri" : "della tua azienda"}.</p>}
            {p?.descrizione && <p className="whitespace-pre-line text-sm text-[#D1D5DB]">{p.descrizione}</p>}
            {p?.website && <a href={/^https?:\/\//.test(p.website) ? p.website : `https://${p.website}`} target="_blank" rel="noreferrer" className="flex items-center gap-1.5 text-sm underline" style={{ color: COPPER }}><Globe className="h-4 w-4" />{p.website}</a>}
            {!mine && (
              <button type="button" onClick={() => onMessage(uid)} data-testid="bacheca-author-message"
                className="flex w-full items-center justify-center gap-2 rounded-full py-2.5 text-xs font-bold uppercase tracking-widest text-white transition-transform hover:-translate-y-0.5" style={{ background: COPPER }}>
                <MessageSquare className="h-4 w-4" /> Scrivi in privato
              </button>
            )}
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}
